module.exports = __webpack_public_path__ + "54cf98f5/img/mini-logo.18817ee5.svg";